import React from 'react';
import PropTypes from 'prop-types';
import Row from 'kepler/lib/components/Row';
import Col from 'kepler/lib/components/Col';
import Button from 'kepler/lib/components/Button';
import getContent from '../lib/dictionaryFetcher';

const AppDetailContentTopVideo = props => {
  const { partner, onClick, videoLink, isDesktop } = props;

  const marketplace = getContent(
      'merchanthub',
      `apps.${partner}.marketplace`,
      ''
    ),
    title = getContent('merchanthub', `apps.${partner}.title`, ''),
    shortDescription = getContent(
      'merchanthub',
      `apps.${partner}.shortDescription`,
      ''
    ),
    getStarted = getContent('merchanthub', `apps.${partner}.getStarted`, '');

  const handleVideoLink = () => {
    window.open(videoLink, '_blank', 'noopener');
  };

  return (
    <Row>
      <Col
        className="marketplace-video-image-container"
        style={{ width: isDesktop ? '16%' : '40%' }}
      >
        <div className={`app-image app-image-sm ${partner}-image`} />
      </Col>
      <Col
        className="marketplace-video-title-container"
        style={{ width: isDesktop ? '36%' : '60%' }}
      >
        <div className="marketplace-type">{marketplace}</div>
        <div className="marketplace-title">{title}</div>
        <div className="marketplace-short-description">
          {shortDescription}
          <Button onClick={onClick} className="get-started-button">
            {getStarted}
          </Button>
        </div>
      </Col>
      <Col
        className="marketplace-video-button-container"
        style={{ width: isDesktop ? '31%' : '100%' }}
      >
        <Button onClick={onClick} className="get-started-button">
          {getStarted}
        </Button>
      </Col>
      <Col
        className="marketplace-video-container"
        style={{ width: isDesktop ? '47%' : '100%' }}
      >
        <div
          className="marketplace-video"
          onClick={handleVideoLink}
          role="link"
          tabIndex={0}
          onKeyDown={e => e.keyCode === 13 && handleVideoLink()}
        />
      </Col>
    </Row>
  );
};

AppDetailContentTopVideo.propTypes = {
  partner: PropTypes.string,
  videoLink: PropTypes.string,
  onClick: PropTypes.func,
  isDesktop: PropTypes.bool
};

export default AppDetailContentTopVideo;
